import RctplAntRadioButton from '@jswork/rctpl-ant-radio-button';

export default props => {
  const { title, items } = props;
  return (
    <View plugin="flexbox:la" align="center" spx={20}>
      <label>{title}</label>
      <nx.$rc.radioGroup
        buttonStyle="solid"
        template={RctplAntRadioButton}
        items={items}
        {...props}
      />
    </View>
  );
};
